// extracted by mini-css-extract-plugin
module.exports = {"primary":"ListItem_primary__1snxP"};